import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../../../components/svgComponents/GameIcon';
import { skillIdsMatch } from '../modals/game/gameSelectorModalUtils';
import { Container, IconImageWrapper, Title, TitleContainer } from './styles/GameIconStyles';

const GameIcon = (
  {
    game: {
      canonicalName: gameId,
      displayName: title,
      skillId,
    },
    onSelectGame,
    completed,
    isStarted,
    selectedGameSkillId,
    style,
    actionName,
  }) => (
    <Container
      style={style}
      aria-label={`Game, ${title}`}
      data-testid={`game-selector-modal-${completed ? 'inactive' : 'active'}-game-${gameId}`}
      data-dd-action-name={actionName}
      completed={completed}
      disabled={completed}
      selected={skillIdsMatch(selectedGameSkillId, skillId)}
      onClick={() => onSelectGame(skillId)}
    >
      <IconImageWrapper canvas={!completed && !isStarted} data-testid="game-selector-modal-game-image">
        <Icon
          gameId={gameId}
          width={95}
          height={97}
        />
      </IconImageWrapper>
      <TitleContainer>
        <Title data-testid="game-selector-modal-game-title">{title}</Title>
      </TitleContainer>
    </Container>
);

export default GameIcon;

GameIcon.propTypes = {
  game: PropTypes.shape({
    canonicalName: PropTypes.string,
    displayName: PropTypes.string,
    skillId: PropTypes.any,
  }).isRequired,
  onSelectGame: PropTypes.func,
  completed: PropTypes.bool,
  isStarted: PropTypes.bool,
  selectedGameSkillId: PropTypes.any,
  style: PropTypes.object,
  actionName: PropTypes.string,
};

GameIcon.defaultProps = {
  completed: false,
  isStarted: false,
  selectedGameSkillId: 0,
  onSelectGame: undefined,
  style: {},
};
